import { Box } from "@chakra-ui/react";

const variantColors = {
  green: "success",
  red: "error",
  yellow: "gold.500",
  blue: "water.500",
  gray: "gray.500",
};

export type Variant = keyof typeof variantColors;

export default function BadgeDot({ variant = "gray" }: { variant: Variant }) {
  return (
    <Box
      backgroundColor={variantColors[variant]}
      borderRadius="50%"
      display="inline-block"
      height="8px"
      mr={2}
      width="8px"
    />
  );
}
